// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  delete_icon,
  edit_icon,
  Search_icon,
  view_icon,
} from "../../assets/img";
import { useLocation, useNavigate } from "react-router-dom";
import { Table } from "../../components/Table/Table";
import Topbar from "../../components/Topbar/Topbar";
import Select from "react-select";
import DateRange from "../../components/DateRange/DateRange";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { customFilterOption } from "../../components/StaticData";
import { checkPermission } from "../redux/api/PermissionManager";
import ReceptionistOnOff from "./ReceptionistOnOff";

const Receptionist = () => {
  const navigate = useNavigate();
  const { paginationData, setpaginationData } = useGlobalContext();
  const location = useLocation();
  const path = location.pathname?.replace("/", "");
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [pagination, setPagination] = useState({});
  const [popup, setPopup] = useState(false);
  const [count, setCount] = useState(0);
  const [selectedFilter, setSelectedFilter] = useState({
    from: paginationData?.[path]?.from ?? "",
    to: paginationData?.[path]?.to ?? "",
    owner: "",
    search: paginationData?.[path]?.search,
  });
  const [optionsList, setOptionsList] = useState({
    owners: [],
  });

  const [receptionList, setReceptionList] = useState([]);

  useEffect(() => {
    getList(page);

    setpaginationData((prev) => ({
      ...prev,
      [path]: { page: page, search: selectedFilter.search },
    }));
  }, [selectedFilter.owner, selectedFilter.search, page]);

  useEffect(() => {
    const { from, to } = selectedFilter;
    if ((from && to) || (!from && !to)) getList(page);
  }, [selectedFilter.from, selectedFilter.to]);

  useEffect(() => {
    getOwnerList();
  }, []);

  // get owners list
  const getOwnerList = async (search) => {
    console.log("search", search);
    const res = await get(
      `${URLS.OWNERS_DROPDOWN}${search ? "?search=" + search : ""}`,
    );
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name, code: item?.code };
      });
      console.log("owner response success", res, modifiedList);
      setOptionsList((prev) => ({ ...prev, owners: modifiedList }));
    }
  };

  const getList = async (pageNumber = 1) => {
    const { owner, from, search, to } = selectedFilter;
    const payload = new FormData();

    if (search) {
      payload.append("search", search);
    }
    if ((from && to) || (!from && !to)) {
      payload.append("from_date", from);
      payload.append("to_date", to);
    }
    if (owner?.value) {
      payload.append("owner_id", owner?.value);
    }
    console.log("paymoad", payload, owner);
    const res = await post(
      `${URLS.RECEPTIONIST_LIST}?page=${pageNumber}`,
      payload,
    );
    console.log("overall properties", res);

    if (res?.status === "success") {
      setCount(res?.count);
      setPagination({
        current_page: pageNumber,
        last_page: res?.next ? pageNumber + 1 : pageNumber,
      });
      setReceptionList(res?.data);
    }
  };

  const handleChangeFilter = (name, val) => {
    if (name !== "from" && val) setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  const handleStatus = async ({ owner_id, status }) => {
    if (!checkPermission("CAN-STATUS-RECEPTIONIST")) return;
    const payload = {
      status: status === 2 ? 1 : 2,
    };
    const res = await post(
      URLS.RECEPTIONIST_LIST_STATUS + owner_id + "/status/",
      payload,
    );
    console.log("reception ist status ", res);
    if (res?.status === "success") {
      toast.success(res?.message);
      getList(page);
    }
  };

  const handleDelete = async (owner_id) => {
    setPopup(false);
    const res = await post(
      URLS.RECPTIONIST_LIST_DELETE + owner_id + "/delete/",
    );
    console.log("receptionist delete ", res);
    if (res?.status === "success") {
      toast.success(res?.message);
      getList(page);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "S.No",
        Cell: ({ row }) => {
          const pageSize = 10;
          return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
        },
      },
      {
        Header: "Owner",
        accessor: "owner__name", // This will give the Owner name as `value`
        Cell: ({ value, row }) => (
          <div className="text-nowrap">
            <p style={{ color: "#AE55F5", fontWeight: "600" }}>{value}</p>
            <p style={{ color: "#AE55F5", fontWeight: "600" }}>
              {`${row.original.owner__code}`}
            </p>
          </div>
        ),
      },
      {
        Header: "Receptionist",
        accessor: "receptionist_count",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Email",
        accessor: "owner__email",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Mobile Number",
        accessor: "owner__mobile",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              <button
                onClick={() => {
                  handleStatus(row.original);
                }}
                className={`${
                  value === 1 ? "active-btn" : "deactive-btn"
                } border-0 ms-2`}
                style={{ fontSize: "12px" }}
              >
                {value === 1 ? " Active" : "De-active"}
              </button>
            </div>
          );
        },
      },

      {
        Header: "Action",
        accessor: "owner_id",
        Cell: ({ row, value }) => (
          <div className="d-flex ac-js">
            {checkPermission("CAN-VIEW-RECEPTIONIST") && (
              <button
                onClick={() => {
                  navigate("/receptionist-action", {
                    state: { type: "view", id: value },
                  });
                }}
                className="cust-btn "
              >
                <img src={view_icon} alt="" className="mx-2 edit-btn " />
              </button>
            )}
            {checkPermission("CAN-EDIT-RECEPTIONIST") && (
              <button
                onClick={() => {
                  navigate("/receptionist-action", {
                    state: { type: "edit", id: value },
                  });
                }}
                className="cust-btn"
              >
                <img src={edit_icon} alt="" className="mx-2 edit-btn" />
              </button>
            )}
            {/* {checkPermission("CAN-DELETE-RECEPTIONIST") && (
              <button onClick={() => setPopup(value)} className="cust-btn">
                <img src={delete_icon} alt="" className="mx-2 edit-btn" />
              </button>
            )} */}
          </div>
        ),
      },
    ],
    [page],
  );

  const formatOptionLabel = ({ label, code }) => (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <span>{label}</span>
      </div>
      <span style={{ fontWeight: 600 }}>{code}</span>
    </div>
  );

  return (
    <div>
      <Topbar header={"Receptionist List"} />

      <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
        Total:{count}
      </h2>
      <div className="d-flex ac-jb mt-3 gap-1 flex-wrap">
        <DateRange
          setFromDate={(date) => {
            handleChangeFilter("from", date);
          }}
          setToDate={(date) => {
            handleChangeFilter("to", date);
          }}
        />
        <Select
          className="location-search"
          options={optionsList?.owners}
          value={selectedFilter?.owner}
          onChange={(e) => handleChangeFilter("owner", e)}
          isClearable
          placeholder={"Property Owner"}
          formatOptionLabel={formatOptionLabel}
          filterOption={customFilterOption}
        />
        <div className="search-input">
          <input
            onChange={(e) => handleChangeFilter("search", e.target.value)}
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "150px" }}
            value={selectedFilter.search}
          />
          <img alt="" src={Search_icon} className="search" />
        </div>
        {checkPermission("CAN-ADD-RECEPTIONIST") && (
          <button
            onClick={() =>
              navigate("/receptionist-action", { state: { type: "add" } })
            }
            className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn "
          >
            {" "}
            + Add New
          </button>
        )}
      </div>

      <ReceptionistOnOff />
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={receptionList}
        show={true}
      />
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => handleDelete(popup)}
                className="add-btn w-40"
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setPopup(false);
                  // logout();
                }}
                className="back-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Receptionist;
